import { motion } from "framer-motion";
import { Shield, Globe, Brain, Cpu, Handshake, Zap } from "lucide-react";

const differentiators = [
  { icon: Shield, title: "Private AI by Design", desc: "Not an afterthought — privacy is our core architecture principle. Every system we build ensures data never leaves client-controlled environments." },
  { icon: Globe, title: "India-First, Global-Ready", desc: "Built for Indian compliance frameworks — RBI, DPDP, and beyond — with architecture that scales globally without compromising sovereignty." },
  { icon: Brain, title: "Multi-Domain Expertise", desc: "Deep expertise spanning BFSI voice AI, smart agriculture, healthcare innovation, and defense systems — each domain informed by real-world deployment." },
  { icon: Cpu, title: "Enterprise-Grade Engineering", desc: "GPU-optimized inference, sub-4s latency voice AI, edge computing capabilities, and production-hardened deployments built for mission-critical use." },
  { icon: Handshake, title: "Trusted Partnerships", desc: "Purpose-built for regulated industries and government collaboration. We understand the compliance, security, and accountability these sectors demand." },
  { icon: Zap, title: "Rapid Deployment", desc: "From concept to production in weeks, not months. Our modular architecture enables swift customization and deployment for enterprise environments." },
];

export const WhyOjasSection = () => (
  <section id="why-ojas" data-testid="why-ojas-section" className="py-24 md:py-32 section-alt relative">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="text-center mb-16"
      >
        <p className="text-[#c9a84c] font-heading font-semibold text-sm tracking-widest uppercase mb-4">
          Differentiators
        </p>
        <h2 className="font-heading font-bold text-3xl sm:text-4xl lg:text-5xl text-foreground tracking-tight">
          Why <span className="text-gradient-gold">Ojas AI</span>
        </h2>
      </motion.div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {differentiators.map((d, i) => (
          <motion.div
            key={d.title}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: i * 0.08 }}
            className="glass-card rounded-lg p-8 group"
            data-testid={`differentiator-${i}`}
          >
            <div className="w-12 h-12 rounded-lg bg-[#c9a84c]/10 flex items-center justify-center mb-5 group-hover:bg-[#c9a84c]/20 transition-colors duration-300">
              <d.icon className="h-6 w-6 text-[#c9a84c]" />
            </div>
            <h3 className="font-heading font-semibold text-foreground text-lg">{d.title}</h3>
            <p className="font-body text-muted-foreground text-sm mt-2 leading-relaxed">{d.desc}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
